<template>
  <v-container>
    <v-layout text-xs-center wrap class="justify-center product-list">
      <v-flex mb-2 xs12>
        <v-flex mt-2>
          <v-btn :to="`/events/${this.$route.params.event_id}`"
            >Event Home</v-btn
          >
        </v-flex>
        <b style="font-size: 1.5em">
          상품 리스트 Products
        </b>
      </v-flex>

      <v-flex
        mb-4
        v-for="product in products"
        :key="product.id"
        xs12
        md6
        lg4
        class="justify-center product"
      >
        {{ product.name }} - {{ product.currency }}
        {{ product.price.toLocaleString() }}
        <br />
        {{ product.description }}
        <br />
        <v-btn :to="`/events/${event_id}/products/${product.id}`" color="info" v-if="is_helpful(product)">
          상품 상세 See Details
        </v-btn>
        <v-btn disabled color="info" v-else>
          Conflicting
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({ event_id: undefined, category: "", products: [] }),
  beforeMount: async function() {
    this.$store.dispatch("loadEvents");
    this.$store.dispatch("loadEventProducts", {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch("loadAttendees");
    this.$store.dispatch('loadEventOrders', {
      event_id: this.$route.params.event_id,
    });

    this.$data.event_id = this.$route.params.event_id;
    this.$data.category = this.$route.params.category;
    this.show_event_products();
  },
  computed: {
    ...mapState(["myprofile", "events", "event_products", "attendees", "event_options_pending", "event_options_confirmed"]),
    helpful_products() {
        return this.$data.products.filter(p => {
            let poptions = p.options.split(",")
            if (poptions.length == 0) return true; // this product has no exclusive options

            let eopending = this.event_options_pending
            let eoconfirmed = this.event_options_confirmed
                
            console.log("PO", 
                JSON.stringify(poptions), 
                JSON.stringify(eopending), 
                JSON.stringify(eoconfirmed), 
                )

            let helpful = true

            poptions.forEach((po) => {
                if (eopending.length > 0) {
                    eopending.forEach(i => {
                        console.log("POCheck1", po, i); 
                        if (po == i) { console.log("POMatch1", po, i); helpful = false; }
                    })
                }
                if (eoconfirmed.length > 0) {
                    eoconfirmed.forEach(i => {
                        console.log("POCheck2", po, i); 
                        if (po == i) { console.log("POMatch2", po, i); helpful = false; }
                    })
                }
            })
            return helpful

            // node8 is dumb and does not have intersection yet
            /*
            let poptions = new Set(p.options.split(","))
            // if (poptions.size == 0) return true; // this product has no exclusive options

            let eopending = new Set(this.event_options_pending)
            let eoconfirmed = new Set(this.event_options_confirmed)
            if (poptions.intersection(eopending).size > 0) return false;
            if (poptions.intersection(eoconfirmed).size > 0) return false;
            */

        })
    }
  },
  watch: {
    event_products(to, from) {
      this.show_event_products();
    },
  },
  methods: {
    show_event_products() {
      this.$data.products = this.event_products.filter(x => {
        return x.category == this.$route.params.category;
      });
    },
    is_helpful(p) {
        console.log("IH", p)
            let poptions = p.options.split(",")
            if (p.multiple) return true; // multiple of same option ok
            if (poptions.length == 0) return true; // this product has no exclusive options

            let eopending = this.event_options_pending
            let eoconfirmed = this.event_options_confirmed
                
            console.log("isPO", 
                JSON.stringify(poptions), 
                JSON.stringify(eopending), 
                JSON.stringify(eoconfirmed), 
                )

            let helpful = true

            poptions.forEach((po) => {
                if (eopending.length > 0) {
                    eopending.forEach(i => {
                        console.log("POCheck1", po, i); 
                        if (po == i) { console.log("POMatch1", po, i); helpful = false; }
                    })
                }
                if (eoconfirmed.length > 0) {
                    eoconfirmed.forEach(i => {
                        console.log("POCheck2", po, i); 
                        if (po == i) { console.log("POMatch2", po, i); helpful = false; }
                    })
                }
            })
            return helpful

            // node8 is dumb and does not have intersection yet
            /*
            let poptions = new Set(p.options.split(","))
            // if (poptions.size == 0) return true; // this product has no exclusive options

            let eopending = new Set(this.event_options_pending)
            let eoconfirmed = new Set(this.event_options_confirmed)
            if (poptions.intersection(eopending).size > 0) return false;
            if (poptions.intersection(eoconfirmed).size > 0) return false;
            */


    },
  },
};
</script>

<style>
.product-list .product {
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
